module.exports = __webpack_public_path__ + "media/pdfs/glass_terms-7350f7ca807959c9ee2db0ea45148a63.pdf";